const EXACT_ALLOWED_NEXT_PATHS = ['/map', '/compare', '/institution-list', '/profile'];

const INSTITUTION_PATH = /^\/institution\/[a-z0-9-]+$/;
const DISTRICT_PATH = /^\/institutioner\/bydel\/[a-z0-9-]+$/;
const UPGRADE_FEATURE = /^[a-z_]+$/;

function isAllowedNextPath(pathOnly) {
  if (EXACT_ALLOWED_NEXT_PATHS.includes(pathOnly)) {
    return true;
  }
  return INSTITUTION_PATH.test(pathOnly) || DISTRICT_PATH.test(pathOnly);
}

function sanitizeNextQuery(rawQuery) {
  if (!rawQuery) {
    return '';
  }
  const params = new URLSearchParams(rawQuery.startsWith('?') ? rawQuery.slice(1) : rawQuery);
  const allowed = new URLSearchParams();
  const upgrade = params.get('upgrade');
  if (upgrade && UPGRADE_FEATURE.test(upgrade)) {
    allowed.set('upgrade', upgrade);
  }
  const serialized = allowed.toString();
  return serialized ? `?${serialized}` : '';
}

/**
 * Returns a same-origin internal path from ?next= if it is on the allowlist.
 * Rejects protocol-relative URLs, other origins, and unknown paths.
 * Allows a safe `upgrade` query so Premium intent survives login/register.
 */
export function getSafeNextPath(search, fallback) {
  if (typeof search !== 'string' || !search) {
    return fallback;
  }
  const raw = new URLSearchParams(search.startsWith('?') ? search : `?${search}`).get('next');
  if (!raw || typeof raw !== 'string') {
    return fallback;
  }
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.includes('\\') || raw.includes('://')) {
    return fallback;
  }
  const pathOnly = raw.split('?')[0].split('#')[0];
  if (pathOnly.includes('..')) {
    return fallback;
  }
  if (!isAllowedNextPath(pathOnly)) {
    return fallback;
  }
  const queryPart = raw.includes('?') ? raw.slice(raw.indexOf('?')).split('#')[0] : '';
  return `${pathOnly}${sanitizeNextQuery(queryPart)}`;
}

export function withNextQuery(to, nextPath) {
  if (!nextPath) return to;
  const separator = to.includes('?') ? '&' : '?';
  return `${to}${separator}next=${encodeURIComponent(nextPath)}`;
}

export function withUpgradeIntent(pathname, feature) {
  if (!pathname) return pathname;
  if (!feature || !UPGRADE_FEATURE.test(feature)) {
    return pathname;
  }
  const separator = pathname.includes('?') ? '&' : '?';
  return `${pathname}${separator}upgrade=${encodeURIComponent(feature)}`;
}
